// extracted by mini-css-extract-plugin
export default {"spoilerContainer":"vfRFqc_G","desktop":"desktop"};